export default {
  setMenu(state, menus) {
    state.menu = menus;
  }
};
